import SerialPort from "./SerialPort";
let currentFilter = -1;
// 前额支架 Forehead support 机器machine
function test() {
  SwitchLampFilter.initPort(undefined, (result) => {
    if (result) {
      SwitchLampFilter.handShake((result) => {});
      setTimeout(() => {
        SwitchLampFilter.openLamp(10, 0, 0, 0, (result) => {});
      }, 100);
      setTimeout(() => {
        SwitchLampFilter.openLamp(0, 10, 0, 0, (result) => {});
      }, 500);
      setTimeout(() => {
        SwitchLampFilter.openLamp(0, 0, 10, 0, (result) => {});
      }, 1000);
      setTimeout(() => {
        SwitchLampFilter.openLamp(0, 0, 0, 10, (result) => {});
      }, 1500);
      setTimeout(() => {
        SwitchLampFilter.closeLamp((result) => {});
      }, 2000);

      // SwitchLampFilter.openLaser(1, (result) => {
      //   console.log('setLaser end')
      // })
      setTimeout(() => {
        SwitchLampFilter.setFilter(1, (result) => {});
      }, 3000);
      setTimeout(() => {
        SwitchLampFilter.closePort();
      }, 10000);
    } else {
      SwitchLampFilter.closePort();
    }
  });
}
function num2HexStr(num, length) {
  return num.toString(16).padStart(length, "0").toUpperCase();
  // return (Array(length).join('0') + num.toString(16)).slice(-length)
}
const SwitchLampFilter = {
  motorCmd: Object.freeze({ stop: 0, left: 1, right: 2 }),
  regListen: function (cb) {
    if (this.device) {
      this.device.regListen(cb);
    }
  },
  isOpen: function () {
    return this.device && this.device.isOpen();
  },
  initPort: function (portPath = "/dev/ttyS0", cb) {
    if (this.device && this.device.isOpen()) {
      this.device.close();
      this.device = null;
    }
    this.device = new SerialPort(portPath);
    this.device.open(cb);
  },
  handShake: function (cb) {
    let cmd = "<0>";
    this.device.write(cmd, (data) => {
      this.doCb(data === "<0>", cb);
    });
  },
  openLamp: function (red, white, green, fixture, cb) {
    var cmd = `<1${num2HexStr(red, 2)}${num2HexStr(white, 2)}${num2HexStr(
      green,
      2
    )}${num2HexStr(fixture, 2)}${num2HexStr(red, 2)}>`;
    this.device.write(cmd, (data) => {
      this.doCb(data === "<1>", cb);
    });
  },
  openInfraredLamp: function (red, cb) {
    red = Math.floor(red);
    var cmd = `<402${num2HexStr(red, 2)}>`;
    this.device.write(cmd, (data) => {
      this.doCb(data === "<4>", cb);
    });
  },
  closeLamp: function (cb) {
    var cmd = "<10000006400>";
    this.device.write(cmd, (data) => {
      this.doCb(data === "<1>", cb);
    });
  },
  closeInfraredLamp: function (cb) {
    var cmd = "<40000>";
    this.device.write(cmd, (data) => {
      this.doCb(data === "<4>", cb);
    });
  },
  getVersion: function (cb) {
    this.doCb(true, cb);
    return;
    let cmd = "<4>";
    this.device.write(cmd, (data) => {
      let isNew = data === "<402>";
      isNew = true;
      this.doCb(isNew, cb);
    });
  },

  // 电机设置需要注意：
  // 如果电机还未转动到指定位置，
  // 此时发送任何其他命令都会导致电机停止转动
  setFilter: function (status, cb) {
    // let status = isLarge ? this.motorCmd.left : this.motorCmd.right
    var cmd = `<2${num2HexStr(status, 2)}>`;

    if (currentFilter === status) {
      let result = true;
      if (cb && typeof cb === "function") {
        cb(result);
      }
      return;
    }
    let result = null;
    this.device.write(
      cmd,
      (data) => {
        if (cb && typeof cb === "function") {
          // 转动电机,会返回两个命令:<2>和(<201>/<202>/<203>)
          if (data.includes(cmd)) {
            currentFilter = status;
            result = true;
            cb(result);
          } else if (data === "failed") {
            currentFilter = status;
            result = false;
            cb(result);
          }
        }
      },
      3000
    );
  },
  openLaserLeft: function (cb) {
    var cmd = "<301>";
    this.device.write(cmd, (data) => {
      this.doCb(data === "<3>", cb);
    });
  },
  closeLaser: function (cb) {
    var cmd = "<300>";
    this.device.write(cmd, (data) => {
      this.doCb(data === "<3>", cb);
    });
  },
  openLaserRight: function (cb) {
    var cmd = "<302>";
    this.device.write(cmd, (data) => {
      this.doCb(data === "<3>", cb);
    });
  },
  closePort: function () {
    this.device.close();
    this.device = null;
  },
  doCb: function (result, cb) {
    if (cb && typeof cb === "function") {
      cb(result);
    }
  }
};
const LiftMotor = {
  liftCmd: Object.freeze({ stop: 0, up: 1, down: 2 }),
  regListen: function (cb) {
    if (this.device) {
      this.device.regListen(cb);
    }
  },
  isOpen: function () {
    return this.device && this.device.isOpen();
  },
  initPort: function (portPath = "/dev/ttyS3", cb) {
    if (this.device && this.device.isOpen()) {
      this.device.close();
      this.device = null;
    }
    this.device = new SerialPort(portPath);
    this.device.open(cb);
  },
  // 升降额托
  upBracket: function (cb) {
    var cmd = "<101>";
    this.device.write(cmd, (data) => {
      this.doCb(data === "<1>", cb);
    });
  },
  // 升降额托
  downBracket: function (cb) {
    var cmd = "<102>";
    this.device.write(cmd, (data) => {
      this.doCb(data === "<1>", cb);
    });
  },
  stopBracket: function (cb) {
    var cmd = "<100>";
    this.device.write(cmd, (data) => {
      this.doCb(data === "<1>", cb);
    });
  },
  // 升降机身
  upMachine: function (cb) {
    let speed = 100;
    this.upMachineWithSpeed(speed, cb);
    // var cmd = '<201>'
    // this.device.write(cmd, data => {
    //   this.doCb(data === '<2>', cb)
    // })
  },
  // 升降机身
  downMachine: function (cb) {
    let speed = 100;
    this.downMachineWithSpeed(speed, cb);
    // var cmd = '<202>'
    // this.device.write(cmd, data => {
    //   this.doCb(data === '<2>', cb)
    // })
  },
  // 升降机身
  upMachineWithSpeed: function (speed, cb) {
    var cmd = `<203${num2HexStr(speed, 2)}>`;
    this.device.write(cmd, (data) => {
      this.doCb(data === "<2>", cb);
    });
  },
  // 升降机身
  downMachineWithSpeed: function (speed, cb) {
    var cmd = `<204${num2HexStr(speed, 2)}>`;
    this.device.write(cmd, (data) => {
      this.doCb(data === "<2>", cb);
    });
  },
  stopMachine: function (cb) {
    var cmd = "<200>";
    this.device.write(cmd, (data) => {
      this.doCb(data === "<2>", cb);
    });
  },
  setStepMotorX(status, cb) {
    if (status !== 0 || status !== 1 || status !== 2) {
      this.doCb(false, cb);
      return;
    }

    let cmd = `<30${status}`;
    this.device.write(cmd, (data) => {
      this.doCb(data === "<3>", cb);
    });
  },
  setStepMotorY(status, cb) {
    if (status !== 0 || status !== 1 || status !== 2) {
      this.doCb(false, cb);
      return;
    }

    let cmd = `<40${status}`;
    this.device.write(cmd, (data) => {
      this.doCb(data === "<4>", cb);
    });
  },
  setStepMotor3(status, cb) {
    if (status !== 0 || status !== 1 || status !== 2) {
      this.doCb(false, cb);
      return;
    }

    let cmd = `<50${status}`;
    this.device.write(cmd, (data) => {
      this.doCb(data === "<5>", cb);
    });
  },
  setBracketSpeed(speed, cb) {
    let cmd = `<7${num2HexStr(speed, 2)}>`;
    this.device.write(cmd, (data) => {
      this.doCb(data === "<7>", cb);
    });
  },
  setBracketSpeed(speed, cb) {
    this.setSpeed(7, speed, cb);
  },
  setMachineSpeed(speed, cb) {
    this.setSpeed(8, speed, cb);
  },
  setStepMotorXSpeed(speed, cb) {
    this.setSpeed(9, speed, cb);
  },
  setStepMotorYSpeed(speed, cb) {
    this.setSpeed(10, speed, cb);
  },
  setStepMotor3Speed(speed, cb) {
    this.setSpeed(11, speed, cb);
  },
  setSpeed(no, speed, cb) {
    let cmd = `<${num2HexStr(no, 1)}${num2HexStr(speed, 2)}>`;
    this.device.write(cmd, (data) => {
      this.doCb(data === `<${num2HexStr(no, 1)}>`, cb);
    });
  },
  doCb(result, cb) {
    if (cb && typeof cb === "function") {
      cb(result);
    }
  },
  closePort: function () {
    this.device.close();
  }
};
global.LampDevice = SwitchLampFilter;
global.LiftDevice = LiftMotor;
global.LampDevice.initPort("/dev/ttyS0", (result, err) => {
  if (!result) {
    console.log("lamp init failed:", err);
  } else {
    // 初始化滤片位置
    global.LampDevice.closeLamp((result) => {
      global.LampDevice.setFilter(2, (result) => {});
    });
    global.LampDevice.closeInfraredLamp((result) => {
      global.LampDevice.setFilter(2, (result) => {});
    });
  }
});
global.LiftDevice.initPort("/dev/ttyS3", (result, err) => {
  if (!result) {
    console.log("lift init failed:", err);
  }
});



// WEBPACK FOOTER //
// ./src/mainInterface/js/SerialDevice.js